var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal-view',{ref:"form",attrs:{"model":_vm.zone,"items":_vm.items,"mainSetting":_vm.modalSetting},on:{"on-cancel":_vm.cancel,"save-success":_vm.save},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}})
}
var staticRenderFns = []

export { render, staticRenderFns }